module.exports = __webpack_public_path__ + "school/img/fazhan.5d00d828.jpg";